import { useEffect } from "react";

export default function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));

    // Reveal items already above the current viewport (e.g. after fast scroll/reload at position)
    const revealAbove = () => {
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.85) {
          el.classList.add("in-view");
        }
      });
    };

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach((el) => obs.observe(el));

    // Initial pass for items already in view
    revealAbove();
    window.addEventListener("scroll", revealAbove, { passive: true });

    return () => {
      obs.disconnect();
      window.removeEventListener("scroll", revealAbove);
    };
  }, []);
}
